// @file Store for wall Timeline V1 format
import device from '@@/bits/device'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export type DashedLineMarginPercentFromViewportBottom = 0.25 | 0.36

export const useSurfaceTimelineFormatStore = defineStore('surfaceTimelineFormatStore', () => {
  const dashedLineMarginPercentFromViewportBottom = ref<DashedLineMarginPercentFromViewportBottom>(0.36)

  const dashedLineMarginBottomClasses = computed(() => {
    if (device.app) return 'mb-36 @tablet-portrait/surface-container:mb-54'

    return dashedLineMarginPercentFromViewportBottom.value === 0.25
      ? 'mb-36 @tablet-portrait/surface-container:mb-[calc(100vh*0.25)]'
      : 'mb-36 @tablet-portrait/surface-container:mb-[calc(100vh*0.36)]'
  })

  const setDashedLineMarginPercentFromViewportBottom = (percent: DashedLineMarginPercentFromViewportBottom): void => {
    dashedLineMarginPercentFromViewportBottom.value = percent
  }

  return {
    dashedLineMarginPercentFromViewportBottom,
    setDashedLineMarginPercentFromViewportBottom,
    dashedLineMarginBottomClasses,
  }
})
